import { wccModules } from 'enums/wccModules';
import { inject, injectable } from 'inversify';
import { ObservableArray, Subscribable } from 'knockout';
import { SimpleTopic } from 'models/simpleTopic';
import { SimpleTopicsGroup } from 'models/simpleTopicsGroup';
import './group.html';
import './group.scss';
import TopicsSliderItem from './item';
import { TopicsSliderTopic } from './topic';

export class TopicsSliderGroup extends TopicsSliderItem {
    topics: Subscribable<Array<TopicsSliderTopic>>

    constructor(public group: SimpleTopicsGroup) {
        super();

        this.topics = this.group.topics.map(topic => new TopicsSliderTopic(topic));
    }

    containsTopic = (topicId: string) => {
        return this.group.topics().some(topic => topic.id() == topicId);
    }
}

@injectable()
export default class TopicsSliderGroupVM {
    topics: ObservableArray<SimpleTopic>

    title: Subscribable<string>
    toDoCount: Subscribable<number>

    ToDoCountShown: Subscribable<boolean>

    constructor(
        @inject(wccModules.componentConfig) model: TopicsSliderGroup,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        const group = model.group;
        this.title = group.title;

        this.topics = group.topics;
        this.toDoCount = this.topics.reduce((result, topic) => result + (topic.shouldBeAnswered() ? 1 : topic.toDoCount()), () => 0);

        this.ToDoCountShown = this.toDoCount.is(count => count > 0);

        ko.applyBindingsToNode(info.element, {
            'css': {
                'task__topics-slider__group': true,
                'task__topics-slider__group--selected': model.isSelected,
                'task__topics-slider__group--not-selected': model.isSelected.not(),
                'task__topics-slider__group--highlighted': model.isHighlighted
            }
        });
    }    
}